export const WEB_AUTH_MARKER_COOKIE = "skylight_web_auth";

const MARKER_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;

export function setWebAuthMarkerCookie() {
  if (typeof document === "undefined") return;
  document.cookie = [
    `${WEB_AUTH_MARKER_COOKIE}=1`,
    "Path=/",
    `Max-Age=${MARKER_MAX_AGE_SECONDS}`,
    "SameSite=Lax",
  ].join("; ");
}

export function clearWebAuthMarkerCookie() {
  if (typeof document === "undefined") return;
  document.cookie = [
    `${WEB_AUTH_MARKER_COOKIE}=`,
    "Path=/",
    "Max-Age=0",
    "SameSite=Lax",
  ].join("; ");
}
